import { Injectable } from '@angular/core';
import { SicorApiService } from '../SicorService/sicor-api.service';
import { take, tap } from 'rxjs/operators';
import { EmergencyType } from '../../models/EmergencyType';
import { SendEmergencyRequest } from '../SicorService/RequestObject/SendEmergencyRequest';
import { AppUserScheduleRequest } from '../SicorService/RequestObject/AppuserScheduleRequest';
import { Schedule } from '../../models/Schedule';
import { GlobalMethodsService } from '../global-methods.service';
import { CommandConnectorQueueInsRequest } from '../SicorService/RequestObject/CommandConnectorQueueInsRequest';
import { GlobalVariablesService } from '../global-variables.service';
import { TranslateConfigService } from 'src/app/services/commons/translate-config.service';
import { NavigationService } from './navigation.service';
import { ModalController } from '@ionic/angular';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlarmService {

  constructor(
    private sicorAPI: SicorApiService,
    private gms: GlobalMethodsService,
    private gvs: GlobalVariablesService,
    private translate: TranslateConfigService,
    private modalCtrl: ModalController,
    private navigation: NavigationService) { }

  public async getEmergencyTypes(requestParams): Promise<EmergencyType[]> {
    let emergencieTypesList: EmergencyType[] = [];
    let servicesList: EmergencyType[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.requestEmergencyTypes(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              res.resultSet.forEach(emergencyType => {
                if (emergencyType.screen_id === 'UA_0120_0010' && emergencyType.screen_name === "Emergencia") {
                  //ATENCION Switch para asociar shortcut_icon_url con el icono a mostrar de la fuente manualmente
                  switch (emergencyType.shortcut_icon_url) {
                    case 'Ambulance_button':
                      emergencyType.show_icon = 'nf-icon-health';
                      break;
                    case 'Fireman_button':
                      emergencyType.show_icon = 'icon-fire';
                      break;
                    case 'Police_button':
                      emergencyType.show_icon = 'icon-accident';
                      break;
                    default:
                      emergencyType.show_icon = 'icon-accident';
                      break;
                  }
                  emergencyType.serviceState = 'disabled';
                  emergencieTypesList.push(emergencyType);
                }
              });
              emergencieTypesList.forEach(emergency => {
                if (emergency.sub_screen_name === 'Response') {
                  servicesList.push(emergency);
                }
              });
              this.gvs.emergencyServices = servicesList;
            }
            resolve(servicesList);
          }, error: async e => {
            resolve(null);
          }
        })
      ));
    });
  }

  public async sendEmergency(requestParams: SendEmergencyRequest, originScreen): Promise<boolean> {
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.sendEmergency(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                if (originScreen === 'alarm') {
                  // this.modalCtrl.dismiss(false,'','loadSpinner');
                  this.gms.setLoadingFalse();
                }
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                resolve(true);
              }
            }
            else {
              resolve(false);
            }
          }, error: e => {
            resolve(null);
          }
        })
      ));
    });
  }

  public async connectDisconnectAlarm(requestParams: CommandConnectorQueueInsRequest, originScreen) {
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.cAppuserCommandConnectorQueueInsRequest(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                resolve(undefined);
                this.modalCtrl.dismiss(false, '', 'loadSpinner');
                if (originScreen === 'connectAlarm') {
                  this.modalCtrl.dismiss(false, '', 'loadingModal');
                  this.modalCtrl.dismiss(false, '', 'connectAlarmModal');
                }
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                resolve(true);
              }
            }
            else {
              resolve(false);
            }
          }, error: e => {
            resolve(false);
          }
        })
      ));
    });
  }

  public async getSchedules(requestParams: AppUserScheduleRequest, originScreen): Promise<Schedule[]> {
    let schedules: Schedule[] = [];
    return new Promise(async (resolve, reject) => {
      await firstValueFrom((await this.sicorAPI.appUserScheduleRequest(requestParams)).pipe(
        take(1),
        tap({
          next: async res => {
            if (res.resultSet != null) {
              if (res.resultSet[0] != null && res.resultSet[0].error != null && res.resultSet[0].error === 401) {
                resolve(undefined);
                if (originScreen === 'alarmPanel') {
                  this.modalCtrl.dismiss(false, '', 'loadSpinner');
                }
                if (originScreen === 'connectAlarm') {
                  this.modalCtrl.dismiss(false, '', 'loadingModal');
                  this.modalCtrl.dismiss(false, '', 'connectAlarmModal');
                }
                await this.gms.clearIntervalStatusInstallationEvent();
                await this.navigation.logout();
                await this.gms.openGenericModal(await this.translate.getTranslate('MODAL.titleError'), await this.translate.getTranslate('MESSAGES.resourceNotAvailable'),
                  'modal-default', await this.translate.getTranslate('BUTTON.agreed'));
              }
              else {
                schedules = res.resultSet;
                resolve(schedules);
              }
            }
          }, error: async e => {
            resolve(null);
            await this.gms.clearIntervalStatusInstallationEvent();
            // await this.gms.openFailedProcessModal();
          }
        })
      ));
    });
  }
}
